import { AnimatePresence, motion } from "framer-motion";
import { createPortal } from "react-dom";
import './bottomSheetAnimate.css'

export const BottomSheetAnimate = ({ bottomSheetStatus, closeBottomSheet, children }) => {
  return createPortal(
    <AnimatePresence>
      {bottomSheetStatus && (
        <>
          {/* Backdrop */}
          <motion.div
            className="sheet-backdrop"
            onClick={closeBottomSheet}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.45 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15, ease: "easeOut" }}
          />

          {/* Sheet */}
          <motion.div
            className="bottom-sheet"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 30, stiffness: 300 }}
          >
            <div className="sheet-handle" onClick={closeBottomSheet} />
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
};
